import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";

import Head from "../components/Head";
import Header from "../components/Header";
import Section from "../components/Section";
import Footer from "../components/Footer";

export default function Template({ data }) {
  const { markdownRemark } = data;
  const { frontmatter, html } = markdownRemark;
  const featuredImgFluid = frontmatter.featuredImage.childImageSharp.fluid;
  const featuredImgSrc = frontmatter.featuredImage.childImageSharp.fluid.src;
  const description = frontmatter.excerpt;

  return (
    <>
      <Head
        img_url={`https://etc4th.site${featuredImgSrc}`}
        description={description}
      />
      <Header />
      <div className="h-24"></div>
      <Section
        bgColor="bg-slate-100"
        textColor="text-slate-400"
        comment="おしらせ"
        isBottom={true}
      >
        <div className="blog-post-container">
          <div className="blog-post relative">
            <Img
              className="rounded-lg drop-shadow-lg mt-8 mb-16"
              fluid={featuredImgFluid}
            />
            <h1 className="text-3xl text-black font-extrabold mb-1">
              {frontmatter.title}
            </h1>
            <p className="text-black mb-8">{frontmatter.date}</p>
            <div
              className="blog-post-content"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
        </div>
      </Section>
      <Footer inIndex={false} />
    </>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        date(formatString: "YYYY年M月D日")
        slug
        title
        excerpt
        featuredImage {
          base
          childImageSharp {
            fluid(maxWidth: 1300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
